import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Title from "./Title";

function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits() {
  return (
    <React.Fragment>
      <Title>Your Account</Title>
      <Typography component="p" variant="h5">
        Ksh 0.00
      </Typography>
      <Typography color="text.secondary" sx={{ flex: 1 }}>
        Balance
      </Typography>
      <Typography component="p" variant="h5">
        Ksh 0.00
      </Typography>
      <Typography color="text.secondary" sx={{ flex: 1 }}>
        Weekly Returns
      </Typography>
    </React.Fragment>
  );
}
